<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="500px"
      style="margin-top:12vh;"
      class="add-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title">添加敏感词</div>
      <el-form label-position="left" :model="addParams" ref="SensitiveWordForm" label-width="60px" class="xForm" center>
        <el-form-item label="分类" prop="wordTypeId">
          <el-select v-model="addParams.wordTypeId" @change="selectChange" :disabled="isDisabled" placeholder="请选择分类">
            <el-option
              v-for="item in options"
              :key="item.wordTypeId"
              :label="item.wordTypeName"
              :value="item.wordTypeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="敏感词" prop="wordName">
          <el-input
            class="word-name-input"
            clearable
            v-model="addParams.wordName"
            autocomplete="off"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 已有敏感词 -->
      <div class="word-name-list-wrap">
        <div class="title">已有敏感词</div>
        <!-- 若没有敏感词 -->
        <div class="tip" v-if="wordNames.length==0">请先添加敏感词</div>
        <!-- 有敏感词 -->
        <div v-else>
          <el-tag
            style="margin:0 4px 8px 0"
            v-for="item in wordNames"
            :key="item.ruleId"
            closable
            type="small"
            @close="delSelectedHandle(item)">
            {{item.wordName}}
          </el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel" style="margin-right:20px">取消</el-button>
        <el-button type="primary" size="small"  @click="confirm" >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getSensitiveWordTypeList,   // 获取分类列表
  addSensitiveWord,           // 添加敏感词
  delSensitiveWord,           // 删除敏感词
  getSensitiveWordList        // 获取敏感词列表
} from "@/api/senWord/senWord.js"
export default {
  name: 'addSensitive',
  data() {
    return {
      dialogVisible: false,
      options: [],
      addParams: {
        wordTypeId: '',
        wordName: ''
      },
      // 获取敏感词列表参数
      getSensiListParams: {
        pageNum: 1,
        pageSize: 9999,
        wordTypeId: '',
        wordName: ''
      },
      currentId: '',
      // 已有敏感词
      wordNames: [],
      deleWordNames: [],
      numble: 0,
      isDisabled:true
    }
  },
  methods: {
    selectChange(val) {
      this.getSensiListParams.wordTypeId = val;
      this.getSensitiveWordList(this.getSensiListParams)
    },
    // 获取敏感词列表
    getSensitiveWordList(params) {
      let that = this;
      getSensitiveWordList(params,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code == 200){
          let tableData = res.data.ruleList;
          that.wordNames = [];
          tableData.forEach(item => {
            let obj = {
              wordName: item.wordName,
              ruleId: item.ruleId
            }
            that.wordNames.push(obj)
          })
        }
      }).catch(err => {
        console.log(err,'errr')
      })
    },
    open(typeId,options) {
      this.deleWordNames = [];
      this.numble =0
      this.isDisabled = true;
      this.addParams.wordTypeId = typeId;
      this.addParams.wordName = '';
      this.getSensiListParams = {
        pageNum: 1,
        pageSize: 9999,
        wordTypeId: typeId,
        wordName: ''
      }
      if(typeId == 'startId') {
        this.addParams.wordTypeId = '';
        this.isDisabled = false;
        this.wordNames = [];
        this.getSensiListParams.typeId = '';
      }else {
        this.getSensitiveWordList(this.getSensiListParams);
      }
      this.options = JSON.parse(JSON.stringify(options[0].children));
      this.dialogVisible = true;
    },
    // 删除
    delSelectedHandle(item) {
      //过滤原始数据
      this.wordNames = this.wordNames.filter(v=>{
        return v.ruleId!=item.ruleId
      })
      this.deleWordNames.push(item)
    },
    // 确定事件
    confirm() {
      let flag = true;
      if(this.addParams.wordTypeId == '') {
        this.$message.warning('请选择分类')
        flag = false;
      }
      if(this.addParams.wordName == '') {
        this.$message.warning('敏感词不能为空')
        flag = false;
      }
      if(flag) {
        let isDup = this.checkDuplicate(this.addParams.wordName,this.deleWordNames);
        if(isDup) {
          // 有重复的敏感词
          this.$message.error('已存在该敏感词，无法再添加！')
        }else {
          this.numble = this.deleWordNames.length;
          if(this.deleWordNames.length == 0) {
            // 不用删除敏感词时直接调用添加敏感词接口
            this.addSensitiveWord(this.addParams)
          }else {
            // 需要删除敏感词时
            this.deleWordNames.forEach(item => {
              this.delSensitiveWord(item.ruleId)
            })
          }
        } 
      }
    },
    // 取消事件
    cancel() {
      this.dialogVisible = false;
    },
    // 判断数组中是否有此敏感词 key: 需要查的敏感词，list敏感词数组
    checkDuplicate(key,list) {
      let flag = false;
      if(this.wordNames.length != 0) {
        for(let i = 0; i< list.length; i++) {
          if(list[i].wordName == key) {
            flag = true;
            break;
          }
        }
      }
      return flag;
    },
    // 删除敏感词
    delSensitiveWord(params) {
      let that = this;
      delSensitiveWord(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          that.numble--
          if(that.numble == 0) {
            that.addSensitiveWord(that.addParams)
          }
        }
      }).catch(err => {
        that.$message.error('删除敏感词失败，请重试！')
        console.log(err,'errr')
      })
    },
    // 添加敏感词
    addSensitiveWord(params) {
      let that = this;
      addSensitiveWord(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
           that.$message.success('添加敏感词成功！')
           that.dialogVisible = false;
           this.$emit("addSuccess",'成功')
        }
      }).catch(err => {
        console.log(err,'errr')
      })
    },
  }
}
</script>

<style scoped lang='scss'>
/deep/.add-dialog {
  color: black;
  .el-dialog__header {
    font-weight: bold;
  }
  .el-dialog__body {
    padding: 0 20px 20px;
    font-size: 14px;
    word-break: break-all;
    .word-name-list-wrap {
      padding-left: 25px;
      padding-bottom: 20px;
      border-bottom: 1px solid #F2F2F2;
      max-height: 250px;
      overflow-y: scroll;
      .title {
        padding: 20px 0 15px;
      }
      .tip {
        padding: 5px;
        background-color: #F1F8FF;
        color: #8F9495;
      }
    }
  }
  .xForm {
    padding: 20px 0 0;
    border-bottom: 1px solid #F2F2F2;
    border-top: 1px solid #F2F2F2;
    .el-form-item {
      padding-left: 25px;
    }
    .el-select {
      width: 80%;
    }
    .word-name-input {
      width: 80%;
    }
  }
}
</style>